import { isMobile } from './helpers';
const DEFAULT_VIDEO_CONSTRAINTS = {
    width: 1280,
    height: 720,
    frameRate: 24
};
const SELECTED_AUDIO_INPUT_KEY = 'gp-selected-audio-input';
const SELECTED_AUDIO_OUTPUT_KEY = 'gp-selected-audio-output';
const SELECTED_VIDEO_INPUT_KEY = 'gp-selected-video-input';
const CONNECTION_OPTIONS = {
    bandwidthProfile: {
        video: Object.assign({ mode: 'collaboration', dominantSpeakerPriority: 'standard', renderDimensions: {
                low: { width: 160, height: 90 },
                standard: { width: 1280, height: 960 },
                high: {
                    width: 1920,
                    height: 1080
                }
            }, maxTracks: 10 }, (isMobile() ? { maxSubscriptionBitrate: 2500000 } : null))
    },
    dominantSpeaker: true,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    networkQuality: { local: 1, remote: 1 },
    maxAudioBitrate: 16000,
    preferredVideoCodecs: [
        {
            codec: 'VP8',
            simulcast: true
        }
    ]
};
export { DEFAULT_VIDEO_CONSTRAINTS, SELECTED_AUDIO_INPUT_KEY, SELECTED_AUDIO_OUTPUT_KEY, SELECTED_VIDEO_INPUT_KEY, CONNECTION_OPTIONS };
//# sourceMappingURL=constants.js.map